/**
      *********************************************************
      Description: Textbox component. xtype can be used to handle the types such as password, email etc.
      Required props:  type, value.
      limitations    : N/A
      *********************************************************
**/
import React, { Component, Fragment, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import DefaultSettings from '../../controls/components/settings';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import VisibilityIcon from '@material-ui/icons/Visibility';
import FormControl from '@material-ui/core/FormControl';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { Fab, InputLabel } from '@material-ui/core';
import Box from '@material-ui/core/Box';

const CFormTextBox = (props) => {
    const { handleFieldChange, onKeyPress, defaultValue, format, value, name, id, tooltip, error, helperText, edit, editduplicate, options, conditions, disabled, accessPermissions, accessLevelPermissions, contexthelp, label, className, required, ...otherProps } = props
    let disabledstatus = conditions && conditions.enable ? conditions.enable : disabled
    const { xtype, inputProps, fullWidth, password, minnumber, minval, hasdecimalvalue } = otherProps;
    let textProps = otherProps
    let val = (value === undefined) ? '' : value;
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    }
    const handleMouseDownPassword = () => {
        setShowPassword(!showPassword);
    }

    const handleNumberChange = (event) => {
        if (minval && event.target.value != '' && event.target.value < minnumber) {
            event.target.value = ''
            props.handleFieldChange(event)
        }
        else if (hasdecimalvalue) {
            props.handleFieldChange(event)
        }
        else {
            event.target.value = parseFloat(event.target.value)
            props.handleFieldChange(event)
        }
    }

    let urlval
    if (val != '' && format === 'URL' && typeof val === 'string') {
        urlval = val.includes("http://") || val.includes("https://") ? val : "http://" + val
    }
    else if (val && typeof val === 'string' && val.includes('?view=embedded')) {
        let temp = val.split('?view=embedded')
        val = temp[0]
    }
    if (edit === false) {
        if (format === 'URL') {
            return <Fragment>
                {(tooltip || contexthelp) && <div > <Typography variant={'subtitle2'} color={'textPrimary'}>{label}&nbsp;
                    < Tooltip title={tooltip ? tooltip : null} placement="bottom-start" >
                        <HelpOutlineIcon fontSize="small" style={{ width: '0.8em' }} onClick={() => DefaultSettings.showDrawer(contexthelp)} />
                    </Tooltip>  </Typography>  <Typography variant={'subtitle2'} color={'black'}>{val}   </Typography>
                </div>}
                {!tooltip && <div > <Typography variant={'subtitle2'} className="fw-bold">{label}&nbsp; </Typography>  <br />
                    <a target={'_blank'} href={urlval}  >{val}   </a>
                </div>}
            </Fragment >
        }
        else return <Fragment>
            <Typography variant={ 'subtitle1'} color={error ? 'red' : ''}>{label}{required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
                {tooltip && <Tooltip title={tooltip ? tooltip : null}
                    placement="bottom-start" >
                    <HelpOutlineIcon color='secondary' fontSize="small" style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
                        onClick={(evt) => contexthelp ?
                            DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
                </Tooltip>}
            </Typography>
            <Typography variant={'subtitle2'} >{val}   </Typography>
        </Fragment >
    }
    else {
        let tlabel = <Typography variant={val || defaultValue || disabled ? 'h6' : 'caption'} color={error ? 'red' : ''}>{label}{required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
            {tooltip && <Tooltip title={tooltip ? tooltip : null}
                placement="bottom-start" >
                <HelpOutlineIcon color='secondary' fontSize="small" style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
                    onClick={(evt) => contexthelp ?
                        DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()} />
            </Tooltip>}
        </Typography>
        textProps = { ...textProps }
        return <TextField onChange={handleFieldChange}
            value={val || defaultValue}
            name={name}
            className={className}
            variant={textProps.variant || 'standard'}
            label={tlabel}
            placeholder={textProps.variant === 'outlined' ? label : ''}
            //  label={variant ? '' : tlabel}
            id={id || name}
            fullWidth
            //required={required}
            helperText={helperText}
            {...textProps}
            error={error}
            //disabled={disabled || false}
            disabled={editduplicate ? false : disabledstatus}
            onKeyPress={onKeyPress}
            type={(password || xtype === "password") ? (showPassword ? 'text' : "password") : (xtype || 'text')}
            InputLabelProps={{
                shrink: (val || defaultValue || disabled) ? true : false,
            }}
            InputProps={{
                endAdornment: xtype === "password" ? (
                    <InputAdornment position="end">
                        <IconButton
                            size='small'
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword} color='primary'
                        >
                            {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        </IconButton>
                    </InputAdornment>
                ) : "", style: { fontWeight: 500 }
            }} />
    }
}
export default CFormTextBox;

// changed from xtype && xtype to xtype || type ( type = passowrod or email)
